import { render, staticRenderFns } from "./documents_share.vue?vue&type=template&id=1ed61116&scoped=true"
import script from "./documents_share.vue?vue&type=script&lang=js"
export * from "./documents_share.vue?vue&type=script&lang=js"
import style0 from "./documents_share.vue?vue&type=style&index=0&id=1ed61116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed61116",
  null
  
)

export default component.exports